import "./i18n";
import { TRANSACTIONS_LIST as BASE_TRANSACTIONS_LIST, PAYMENTS_TO_APPROVE_LIST as BASE_PAYMENTS_TO_APPROVE_LIST, READY_FOR_PAYMENT_LIST as BASE_READY_FOR_PAYMENT_LIST, TRANSACTIONS_CREATE as BASE_TRANSACTIONS_CREATE, TRANSACTIONS_EDIT as BASE_TRANSACTIONS_EDIT, TRANSACTIONS_VIEW as BASE_TRANSACTIONS_VIEW, } from "./config/routes";
export const TRANSACTIONS_LIST = {
    ...BASE_TRANSACTIONS_LIST,
};
export const PAYMENTS_TO_APPROVE_LIST = {
    ...BASE_PAYMENTS_TO_APPROVE_LIST,
};
export const READY_FOR_PAYMENT_LIST = {
    ...BASE_READY_FOR_PAYMENT_LIST,
};
export const TRANSACTIONS_CREATE = {
    ...BASE_TRANSACTIONS_CREATE,
};
export const TRANSACTIONS_EDIT = {
    ...BASE_TRANSACTIONS_EDIT,
};
export const TRANSACTIONS_VIEW = {
    ...BASE_TRANSACTIONS_VIEW,
};
